import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-init',
  templateUrl: './init.component.html',
  styles: []
})
export class InitComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
